// extracted by mini-css-extract-plugin
export default {"top":"NavPanel_top__9qB-A","main":"NavPanel_main__Wrh6t","arrowRightImg":"NavPanel_arrowRightImg__ERWra","section":"NavPanel_section__8FhfF"};